import {valuableCardValue} from '@kapitalist/contract/ruleset'
import type {TCashCardData} from '@kapitalist/contract/types'
import type {TMillions} from '@kapitalist/contract/types/millions'
import type {TSkinData} from '~/game/skins/types'
import Card from '~/models/game/Card'
import MajorActionPlayAsCash from '~/models/game/MajorActions/MajorActionPlayAsCash'
import type {AnyMajorAction} from '~/models/game/types'

export default class CashCard extends Card<TCashCardData> {
  public value: TMillions

  constructor(data: TCashCardData) {
    super(data)
    this.value = valuableCardValue[data.type]
  }

  public fileName(skinData: TSkinData): string {
    return `cash_${this.type}${skinData.cash === 'identical' ? '' : this.version}`
  }

  public availableMovesFromHand(): AnyMajorAction[] {
    return [
      new MajorActionPlayAsCash({
        card: this.datasource,
        type: 'playAsCash',
      }),
    ]
  }
}
